import { Col, Input, Label, Row } from "reactstrap";
import SelectMemberUnit from "../member/SelectMemberUnit";
import { useEffect, useState } from "react";
import { GetLanguageString } from "../helper/Components";
import SelectUnitForMember from "./SelectUnitForMember";
import { encryptStorage } from "../../constants/EncryptStorage";

const SelectUnitRequestMoveMember = ({
  values,
  setValues,
  unitId,
  canBeTransferredOutside,
  showExcludeUnit,
  errors,
  setErrors,
  setNotificationAction,
}) => {
  const unitTypeName = encryptStorage.getItem("unitTypeName");
  const loggedInUnitId = encryptStorage.getItem("loggedInUnitId");
  const [check, setCheck] = useState("Inside");

  useEffect(() => {
    let temp = {};
    temp.unitId =
      values.unit.value === 0 ? (
        <GetLanguageString props="unit_unitmember_empty_unit_error_message" />
      ) : (
          check === "Outside"
            ? values.unit.unitTypeName !== unitTypeName &&
              unitTypeName === "Halqa"
            : ""
        ) ? (
        <GetLanguageString props="unit_unitmember_halqa_unit_error_message" />
      ) : (check === "Outside" && loggedInUnitId === values.unit.value) ||
        (check === "Local" && unitId === values.unit.value) ? (
        <GetLanguageString props="unit_unitmember_halqa_unit_error_message" />
      ) : (
        ""
      );
    setErrors({
      ...temp,
    }); // eslint-disable-next-line
  }, [values.unit, check, loggedInUnitId, unitId, unitTypeName]);

  return (
    <div>
      {canBeTransferredOutside ? (
        <>
          <Row>
            <Col md="6">
              <Label className="col-form-label">
                <Input
                  type="radio"
                  name="check"
                  className="m-1"
                  value="Inside"
                  checked={check === "Inside"}
                  onChange={() => {
                    setCheck("Inside");
                    setNotificationAction((prev) => ({
                      ...prev,
                      generateNewNotification: false,
                    }));
                    setErrors({});
                  }}
                />
                <GetLanguageString props="unit_unitmember_move_member_localy" />
              </Label>
            </Col>
            <Col md="6">
              <Label className="col-form-label">
                <Input
                  type="radio"
                  name="check"
                  className="m-1"
                  value="Outside"
                  checked={check === "Outside"}
                  onChange={() => {
                    setCheck("Outside");
                    setNotificationAction((prev) => ({
                      ...prev,
                      generateNewNotification: true,
                    }));
                  }}
                />
                <GetLanguageString props="unit_unitmember_move_members_other" />
              </Label>
            </Col>
          </Row>

          {check === "Inside" ? (
            <SelectMemberUnit
              loggedInUnitId={unitId}
              unitId={unitId}
              setValues={setValues}
              values={values}
              showExcludeUnit={showExcludeUnit}
            />
          ) : (
            <div>
              <br />
              <SelectUnitForMember
                values={values}
                setValues={setValues}
                setErrors={setErrors}
                unitId={unitId}
                check={check}
              />
              {errors.unitId ? (
                <h4 className="text-error">*{errors.unitId}</h4>
              ) : null}
            </div>
          )}
        </>
      ) : (
        <SelectMemberUnit
          loggedInUnitId={unitId}
          unitId={unitId}
          setValues={setValues}
          values={values}
          showExcludeUnit={showExcludeUnit}
        />
      )}
    </div>
  );
};

export default SelectUnitRequestMoveMember;
